import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import { logExportacaoDados } from '../../services/logs/logsAcoesService';
import { formatDate } from '../functions';

export interface ExportSheet {
  name: string;
  data: any[];
  columns?: Record<string, string>; // mapeamento campo -> título da coluna
}

export interface ExportConfig {
  filename: string;
  sheets: ExportSheet[];
  userId?: number;
  entityName?: string;
  interfaceName?: string;
}

export async function exportToExcel(config: ExportConfig): Promise<void> {
  const workbook = XLSX.utils.book_new();

  config.sheets.forEach((sheet) => {
    if (!sheet.data || sheet.data.length === 0) return;

    // Aplica mapeamento de colunas se fornecido
    let processedData = sheet.data;
    if (sheet.columns) {
      processedData = sheet.data.map((row) => {
        const mappedRow: any = {};
        Object.entries(row).forEach(([key, value]) => {
          const columnName = sheet.columns?.[key] ?? key;
          mappedRow[columnName] = formatCellValue(value, key);
        });
        return mappedRow;
      });
    }

    const worksheet = XLSX.utils.json_to_sheet(processedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
  });

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  saveAs(blob, config.filename);

  // Log opcional
  if (config.userId && config.entityName) {
    await logExportacaoDados(config.userId, config.entityName);
  }
}

// Função auxiliar para formatar valores das células
function formatCellValue(value: any, fieldName: string): any {
  if (value === null || value === undefined) return '';

  // Formatar datas
  if (
    (fieldName.toLowerCase().includes('data') ||
      fieldName.toLowerCase().includes('date')) &&
    value
  ) {
    return formatDate(value);
  }

  // Formatar valores monetários
  if (fieldName.toLowerCase().includes('valor') && typeof value === 'number') {
    return parseFloat(value.toString()).toFixed(2);
  }

  return value;
}
